// Module
var code = "<summary class=\"view-summary\">\n  <hero-heading v-if=\"heroHeading\" :heading=\"heading\" />\n  <h1 v-if=\"!heroHeading\">{{ heading }}</h1>\n  <slot></slot>\n</summary>\n";
// Exports
export default code;